// extracted by mini-css-extract-plugin
export default {"contentCatalog":"Display_contentCatalog__46Xui","content":"Display_content__GrK4-"};